// The bars across the top of the window (the beta bar, and the impersonation
// banner above it while impersonating) publish their combined height here so
// the page, sidebar, drawers and dialogs can all start below them instead of
// sliding underneath. Until the bars have been measured the offset is 0px.
export const BANNER_HEIGHT_VAR = '--top-bars-height';
export const BANNER_OFFSET = `var(${BANNER_HEIGHT_VAR}, 0px)`;

// The part of the window below the bars. Full-height pages use this rather
// than 100vh, which would always scroll by the bars' height.
export const HEIGHT_BELOW_BARS = `calc(100vh - ${BANNER_OFFSET})`;
